import { mainApi } from '../../../api/mainApi';
import { AccessState, AuthState } from '../../../types';
import { middlewareApi } from '../../middleware/middlewareApi';
import { RedlinksResponse } from '../interfaces/redlinks.interface';

import { getYear } from 'date-fns';
import axios from 'axios';

export const redlinksTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['RedlinksInfo'],
});
// Define a service using a base URL and expected endpoints
export const redlinksApi = redlinksTags.injectEndpoints({
  endpoints: (builder) => ({
    /**
     *
     * @POST get Redlinks Avatar
     */
    getRedlinksAvatar: builder.mutation<
      RedlinksResponse,
      { identification?: string; year?: string }
    >({
      queryFn: async ({ identification, year }, { getState }) => {
        try {
          const {
            access: {
              defaultConfiguration: { redLinksPhotoId, redLinksToken },
            },
            auth: { userInfo },
          } = getState() as { access: AccessState; auth: AuthState };

          const tempToken =
            'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9hZG1pbnJlZGxpbmtzX2FwcC50ZXN0XC9hcGlcL2xvZ2luIiwiaWF0IjoxNjUxMTc1Mjg4LCJleHAiOjE5NjY1MzUyODgsIm5iZiI6MTY1MTE3NTI4OCwianRpIjoiT2RCRTJKcTVNYWFaM1Z2bSIsInN1YiI6MTAzMTMsInBydiI6Ijg3ZTBhZjFlZjlmZDE1ODEyZmRlYzk3MTUzYTE0ZTBiMDQ3NTQ2YWEifQ.5TpgPnqMqaVgcdXP4TrnIcyyYW0e8NU5OEnLg9zeW9A';

          const { data } = await mainApi.post<RedlinksResponse>(
            `https://appnew.redlinks.com.ec/api/buscarCarnetRedlinks`,
            {
              cedula: identification || userInfo.identification,
              empresa_id: redLinksPhotoId,
              anio: year || getYear(new Date()),
            },
            { headers: { Authorization: `Bearer ${redLinksToken || tempToken}` } }
          );
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error) => [{ type: 'RedlinksInfo', id: 'LIST' }],
    }),

    /**
     *
     * @Get get Redlinks Avatar verbo get (alternative)
     */
    getRedlinksAvatarQuery: builder.query<
      RedlinksResponse,
      { identification?: string; year?: string }
    >({
      queryFn: async ({ identification, year }, { getState }) => {
        try {
          const {
            access: {
              defaultConfiguration: { redLinksPhotoId, redLinksToken },
            },
            auth: { userInfo },
          } = getState() as { access: AccessState; auth: AuthState };

          const tempToken =
            'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9hZG1pbnJlZGxpbmtzX2FwcC50ZXN0XC9hcGlcL2xvZ2luIiwiaWF0IjoxNjUxMTc1Mjg4LCJleHAiOjE5NjY1MzUyODgsIm5iZiI6MTY1MTE3NTI4OCwianRpIjoiT2RCRTJKcTVNYWFaM1Z2bSIsInN1YiI6MTAzMTMsInBydiI6Ijg3ZTBhZjFlZjlmZDE1ODEyZmRlYzk3MTUzYTE0ZTBiMDQ3NTQ2YWEifQ.5TpgPnqMqaVgcdXP4TrnIcyyYW0e8NU5OEnLg9zeW9A';

          const { data } = await axios.post<RedlinksResponse>(
            `https://appnew.redlinks.com.ec/api/buscarCarnetRedlinks`,
            {
              cedula: identification || userInfo.identification,
              empresa_id: redLinksPhotoId,
              anio: year || getYear(new Date()),
            },
            { headers: { Authorization: `Bearer ${redLinksToken || tempToken}` } }
          );
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result, error) => [{ type: 'RedlinksInfo', id: 'LIST' }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetRedlinksAvatarMutation, useGetRedlinksAvatarQueryQuery } = redlinksApi;
